import { render, staticRenderFns } from "./Bigpackage.vue?vue&type=template&id=a3776aca&scoped=true&"
import script from "./Bigpackage.vue?vue&type=script&lang=js&"
export * from "./Bigpackage.vue?vue&type=script&lang=js&"
import style0 from "./Bigpackage.vue?vue&type=style&index=0&id=a3776aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3776aca",
  null
  
)

export default component.exports